<template>
  <section>
    <div style="display: none">
      <div id="report_holder"></div>
    </div>
    <div>
      <el-col :span="2">
        <el-input
          v-model="filters.license"
          placeholder="车号/车牌"
          @change="getWeighingOut(1)"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          v-model="filters.code"
          width="100px"
          placeholder="编号/任务编号/出货单号/工程名称"
          @change="getWeighingOut(1)"
        ></el-input>
      </el-col>
      <!-- <el-col :span="3">
        <el-input
          v-model="filters.taskCode"
          width="100px"
          placeholder="任务编号"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          v-model="filters.outMasterCode"
          width="100px"
          placeholder="出货单号"
        ></el-input>
      </el-col>

      <el-col :span="3">
        <el-input
          v-model="filters.projectName"
          width="100px"
          placeholder="工程名称"
        ></el-input>
      </el-col> -->
      <el-col :span="3">
        <el-select
          v-model="filters.weightID"
          placeholder="选择磅秤"
          :clearable="true"
          @change="getWeighingOut(1)"
        >
          <el-option
            v-for="item in whsettingListSelect"
            :key="item.Id + '_bc'"
            :label="item.Name"
            v-model="item.Id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="filters.status"
          placeholder="请选择状态"
          @change="getWeighingOut(1)"
        >
          <el-option label="所有" :value="-1"></el-option>
          <el-option label="已打印" :value="200"></el-option>
          <el-option label="已完成" :value="300"></el-option>
          <el-option label="已作废" :value="-100"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getWeighingOut(1)">查询</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-col>
    </div>

    <!--列表-->
    <el-table
      :data="WeighingOut"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column prop="Code" label="磅单信息">
        <template slot-scope="scope">
          <div>
            <el-tag :type="scope.row.WeightType == 100 ? 'success' : 'warning'">
              {{ scope.row.WeightType == 100 ? "补" : "磅" }}
            </el-tag>
            磅单号：
            <el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.Code }}
            </el-link>
            过磅方量：
            <span class="table-value">
              {{ scope.row.WeighingQuantity }}
            </span>
            容重：
            <span class="table-value">
              {{ scope.row.DiscountCubRate }}
            </span>
            发货方量：
            <span class="table-value">{{ scope.row.Quantity }}</span>
          </div>
          <div>
            生产线：
            <span class="table-value">
              {{ scope.row.StationLineName }}
            </span>
            车号：
            <span class="table-value">
              {{ scope.row.VehicleErpCode }}
            </span>
            车牌：
            <span class="table-value">{{ scope.row.License }}</span>
            强度：
            <span class="table-value">{{ scope.row.GradeName }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="Remark" label="工程信息">
        <template slot-scope="scope">
          <div>
            工程：
            <span class="table-value">
              {{ scope.row.ProjectName }}
            </span>
          </div>
          <div>
            部位：
            <span class="table-value">
              {{ scope.row.ProjectPart }}
            </span>
            任务单：
            <span class="table-value">{{ scope.row.TaskCode }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="Remark" label="过磅累计" >
        <template slot-scope="scope">
          <div>
            累计方量：
            <span class="table-value">
              {{ scope.row.TaskTotalQuantity }}
            </span>
            <br />
            累计车次：
            <span class="table-value">
              {{ scope.row.TaskTotalTruckCount }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="Remark" label="重量信息">
        <template slot-scope="scope">
          <div>
            毛重：
            <span class="table-value">{{ scope.row.GrossWeight }}</span>
            <br />
            皮重：
            <span class="table-value">{{ scope.row.TareWeight }}</span>
          </div>
          <br />
          <div>
            扣重：
            <span class="table-value">{{ scope.row.BuckleWeight }}</span>
            <br />
            净重：
            <span class="table-value">{{ scope.row.NetWeight }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.Status == 0
                ? 'success'
                : scope.row.Status == 200
                ? 'warning'
                : 'info'
            "
            disable-transitions
          >
            {{
              scope.row.Status == 0
                ? "新建"
                : scope.row.Status == 200
                ? "已打印"
                : scope.row.Status == 300
                ? "已完成"
                : "已作废"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link
            type="danger"
            size="mini"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
          <el-link
            type="primary"
            size="mini"
            v-if="scope.row.Status != -100"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            修改
          </el-link>
          <el-link
            type="info"
            size="mini"
            v-if="scope.row.Status != -100"
            @click="
              () => {
                print(scope.row.Id);
              }
            "
          >
            打印{{ scope.row.PrintCount }}
          </el-link>
          <el-link
            type="info"
            size="mini"
            v-if="scope.row.Status != -100"
            @click="
              () => {
                printOutmaster(scope.row.ProudOutMasterID);
              }
            "
          >
            打印出货单
          </el-link>
          <el-link
            type="success"
            size="mini"
            v-if="scope.row.Status == 200 && scope.row.Status != -100"
            @click="
              () => {
                currentRow = scope.row;
                handleComplete();
              }
            "
          >
            完成
          </el-link>
          <el-link
            type="primary"
            v-if="scope.row.Status != -100"
            @click="
              () => {
                currentRow = scope.row;
                handleAbandon();
              }
            "
          >
            作废
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
    <!--编辑界面-->
    <el-dialog
      :title="isEdit ? '编辑' : '新增'"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <!-- 添加编辑 -->
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
        class="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="车号">
              <template>
                <el-select
                  v-model="editForm.VehicleErpCode"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  default-first-option
                  @change="changeLicense"
                  @click.native="remoteMethod('')"
                  placeholder="请选择单据"
                >
                  <el-option
                    v-for="item in proOutMasterList"
                    :key="item.Id + '_carcode'"
                    :label="item.VehicleErpCode"
                    :value="item.Id"
                    style="height: 150px"
                  >
                    <div>
                      <span>
                        车号:{{ item.VehicleErpCode }} 车牌:{{
                          item.License
                        }}
                        方量{{ item.QuantityTotal }}
                      </span>
                      <br />
                      <span>
                        发货单号:{{ item.Code }} 任务:{{ item.TaskCode }}
                      </span>
                      <br />
                      <span>
                        工程:{{ item.ProjectName }} 强度:{{ item.GradeName }}
                      </span>
                    </div>
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="磅秤">
              <el-select
                v-model="editForm.WeightID"
                placeholder="选择磅秤"
                :clearable="true"
              >
                <el-option
                  v-for="item in whsettingListSelect"
                  :key="item.Id + '_bc1'"
                  :label="item.Name"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="毛重">
              <el-input
                v-model="editForm.GrossWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务单编号">
              <el-input v-model="editForm.TaskCode" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产方量">
              <el-input v-model="editForm.Quantity" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="皮重">
              <el-input
                v-model="editForm.TareWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣重">
              <el-input
                v-model="editForm.BuckleWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出货单编号">
              <el-input
                v-model="editForm.ProdOutMasterCode"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣除率">
              <el-input
                v-model="editForm.DeductionRate"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货累计">
              {{ editForm.QuantityTotal }}方/{{ editForm.VehiclesTotal }}车
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="净重">
              <el-input v-model="editForm.NetWeight" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过磅累计">
              {{
                Number(editForm.TaskTotalQuantity) +
                Number(editForm.WeighingQuantity)
              }}方/{{ editForm.TaskTotalTruckCount }}车
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="容重">
              <el-input v-model="editForm.DiscountCubRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过磅方量">
              <el-input v-model="editForm.WeighingQuantity"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="editForm.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotGList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotGList"
            :key="i + 'shotG'"
          >
            <img
              :id="'shotG_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotTList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotTList"
            :key="i + 'shotT'"
          >
            <img
              :id="'shotT_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
      width="70%"
    >
      <el-form :model="DetailDm" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="车号">
              {{ DetailDm.VehicleErpCode }} 车牌:{{ DetailDm.License }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="方量">
              {{ DetailDm.QuantityTotal }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工程">
              {{ DetailDm.ProjectName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部位">
              {{ DetailDm.ProjectPart }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产线">
              {{ DetailDm.StationLineName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="强度">
              {{ DetailDm.GradeName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="毛重">
              {{ DetailDm.GrossWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务单编号">
              {{ DetailDm.TaskCode }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产方量">
              {{ DetailDm.Quantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="皮重">
              {{ DetailDm.TareWeight }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣重">
              {{ DetailDm.BuckleWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出货单编号">
              {{ DetailDm.ProdOutMasterCode }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣除率">
              {{ DetailDm.DeductionRate }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发货累计">
              {{ DetailDm.QuantityTotal }}方/{{ DetailDm.VehiclesTotal }}车
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="净重">
              {{ DetailDm.NetWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过磅累计">
              {{
                Number(DetailDm.TaskTotalQuantity) +
                Number(DetailDm.WeighingQuantity)
              }}方/{{ DetailDm.TaskTotalTruckCount }}车
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="容重">
              {{ DetailDm.DiscountCubRate }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过磅方量">
              {{ DetailDm.WeighingQuantity }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              {{ DetailDm.Remark }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotGList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotGList"
            :key="i + 'shotG'"
          >
            <img
              :id="'shotG_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotTList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotTList"
            :key="i + 'shotT'"
          >
            <img
              :id="'shotT_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <!-- 从这里结束 -->
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
//引入whsetting.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/weighingOut";
import { BaseApiUrl } from "../../api/api";
import { getPrintContent } from "../../api/prodoutmaster";
//import {getWeight} from "../../api/wcf";
import originJSONP from "jsonp";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import printJS from "print-js";
import { runReport } from "../../api/viewReport";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        code: "",
        weightID: "",
        status: -1,
        // projectName: "",
        // outMasterCode: "",
        // taskCode: "",
      },
      editFormVisible: false, //编辑界面是否显示
      buttonList: [], //按钮列表
      whsettingListSelect: [], //磅秤列表
      whsettingListTop: [], //磅秤列表
      whsettingTopId: "",
      whsetting: {}, //当前选择磅秤
      editFormRules: {
        // MatName: [
        //   { required: true, message: "请输入物资名称", trigger: "blur" },
        // ],
      },
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      editForm: {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 0,
        TaskTotalQuantity: 0,
        WeighingQuantity: 0,
      }, //编辑数据
      WeighingOut: [], //过磅数据列表
      currentRow: {}, //当前选择列
      whnumber: 888,
      editLoading: false,
      isEdit: false,
      loading: false,
      TarePrint: false, //是否过皮并打印
      proOutMasterList: [], //待过磅的出货单
      isShowDetail: false,
      DetailDm: {},
      shotGList: [], //过毛拍照List
      shotTList: [], //过皮拍照List
    };
  },
  computed: {},
  methods: {
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getWeighingOut();
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailDm = row;
      this.shotTList = [];
      this.shotGList = [];
      this.isShowDetail = !this.isShowDetail;
      if (row.ImageFilePathGross.length > 0) {
        var UploadUrls = row.ImageFilePathGross;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotGList = souceImgFile;
      }
      if (row.ImageFilePathTare.length > 0) {
        var UploadUrls = row.ImageFilePathTare;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotTList = souceImgFile;
      }
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getWeighingOut(1);
    },
    cancel() {
      this.isEdit = false;
      this.editForm = {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 0,
        TaskTotalQuantity: 0,
        WeighingQuantity: 0,
      };
    },
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          //this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteWeighingOut(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getWeighingOut();
          });
        })
        .catch(() => {})
        .finally(() => {
          //this.listLoading = false;
        });
    },
    //完成
    handleComplete() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .completeWeighingOut(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getWeighingOut();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //作废
    handleAbandon() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .cancelWeighingOut(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    print(Id) {
      let para = {
        id: Id,
      };
      api.getPrintContent(para).then((res) => {
        this.getWeighingOut();
        this.listLoading = false;
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i >= 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    printOutmaster(id) {
      let para = {
        id: id,
      };
      getPrintContent(para).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i >= 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //获取过磅列表
    getWeighingOut(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        license: this.filters.license,
        status: this.filters.status,
        weightID: this.filters.weightID,
        code: this.filters.code,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getWeighingOutHistryListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.WeighingOut = res.data.response.data;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    //获取磅秤列表
    getWhsettingDetail() {
      let para = {
        key: 100,
      };
      this.listLoading = true;
      api.getWhsettingDetail(para).then((res) => {
        if (res.data.response && res.data.response.length > 0) {
          this.whsettingListSelect = res.data.response;
          this.whsettingListTop = res.data.response;
          if (window.localStorage.WhOut1Com) {
            this.whsetting = JSON.parse(window.localStorage.WhOut1Com);
            this.whsettingTopId = this.whsetting.Id;
          } else {
            this.whsetting = res.data.response[0];
            this.whsettingTopId = res.data.response[0].Id;
          }
        }
      });
    },
    selectWhsetting(id) {
      this.whsetting = this.whsettingListTop.filter((e) => e.Id == id)[0];
      window.localStorage.WhOut1Com = JSON.stringify(this.whsetting);
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.isEdit = true;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.shotTList = [];
      this.shotGList = [];
      if (row.ImageFilePathGross.length > 0) {
        var UploadUrls = row.ImageFilePathGross;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotGList = souceImgFile;
      }
      if (row.ImageFilePathTare.length > 0) {
        var UploadUrls = row.ImageFilePathTare;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotTList = souceImgFile;
      }
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.editFormVisible = true;
      this.shotTList = [];
      this.shotGList = [];
      this.editForm = {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 100,
        TaskTotalQuantity: 0,
        WeighingQuantity: 0,
      };
    },
    editSubmit() {
      this.editForm.WeightID = this.whsetting.Id;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editWeighingOut(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editForm = {};
                  this.getWeighingOut();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          } else {
            api
              .addWeighingOut(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editForm = {};
                  this.getWeighingOut();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          }
          this.editFormVisible = false;
        }
      });
    },
    //计算净重
    NetWeightCount() {
      var grossWeight =
        this.editForm.GrossWeight == "" ||
        this.editForm.GrossWeight == undefined
          ? 0
          : Number(this.editForm.GrossWeight);
      var tareWeight =
        this.editForm.TareWeight == "" || this.editForm.TareWeight == undefined
          ? 0
          : Number(this.editForm.TareWeight);
      var cubRate =
        this.editForm.DiscountCubRate == "" ||
        this.editForm.DiscountCubRate == undefined
          ? 0
          : Number(this.editForm.DiscountCubRate);

      var buckleWeight =
        this.editForm.BuckleWeight == "" ||
        this.editForm.BuckleWeight == undefined
          ? 0
          : Number(this.editForm.BuckleWeight); //扣重1 扣重(kg)
      var deductionRate =
        this.editForm.DeductionRate == "" ||
        this.editForm.DeductionRate == undefined
          ? 0
          : Number(this.editForm.DeductionRate); //扣重2 扣重(%)
      var deductWeight2 = ((grossWeight * deductionRate) / 100).toFixed(0);
      this.editForm.NetWeight = Number(
        grossWeight - tareWeight - buckleWeight - deductWeight2
      ).toFixed(2);
      if (this.editForm.DiscountCubRate > 0) {
        this.editForm.WeighingQuantity = (
          Number(this.editForm.NetWeight) / cubRate
        ).toFixed(2);
      }
    },
    remoteMethod(query) {
      let para = {
        license: query,
      };
      api.getOutMasterHistry(para).then((res) => {
        if (res.data.response != null) {
          this.proOutMasterList = res.data.response.ProdOutMasterWhOutViewModel;
        }
      });
    },
    changeLicense(obj) {
      var prodOutMasterItem = this.proOutMasterList.filter(
        (e) => e.Id == obj
      )[0];
      this.editForm.TaskCode = prodOutMasterItem.TaskCode;
      this.editForm.TaskID = prodOutMasterItem.TaskID;
      this.editForm.ProudOutMasterID = prodOutMasterItem.Id;
      this.editForm.ProdOutMasterCode = prodOutMasterItem.Code;
      this.editForm.VehicleErpCode = prodOutMasterItem.VehicleErpCode;
      this.editForm.VehicleID = prodOutMasterItem.VehicleID;
      this.editForm.License = prodOutMasterItem.License;
      this.editForm.TaskTotalQuantity = prodOutMasterItem.TaskTotalQuantity;
      this.editForm.TaskTotalTruckCount =
        prodOutMasterItem.TaskTotalTruckCount + 1;
      this.editForm.VehiclesTotal = prodOutMasterItem.VehiclesTotal;
      this.editForm.QuantityTotal = prodOutMasterItem.QuantityTotal;
      this.editForm.TareWeight = prodOutMasterItem.CarWeight;
      this.editForm.DiscountCubRate = prodOutMasterItem.Weight;
      this.editForm.Quantity = prodOutMasterItem.Quantity;
      this.editForm.ProjectPart = prodOutMasterItem.ProjectPart;
      this.editForm.GradeID = prodOutMasterItem.GradeID;
      this.editForm.GradeName = prodOutMasterItem.GradeName;
      this.editForm.ProjectID = prodOutMasterItem.ProjectID;
      this.editForm.ProjectName = prodOutMasterItem.ProjectName;
      this.editForm.StationLineID = prodOutMasterItem.StationLineID;
      this.editForm.StationLineName = prodOutMasterItem.StationLineName;
      this.NetWeightCount();
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getWhsettingDetail();
    this.getWeighingOut();
  },
};
</script>

<style scoped>
.flex-row {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-row.between {
  justify-content: space-between;
}
.flex-row.wrap {
  flex-wrap: wrap;
}

.editForm .el-select {
  width: 100%;
}

.number {
  height: 100px;
  width: 80%;
  line-height: 100px;
  text-align: center;
  font-size: 5rem;
  background: rgb(247, 244, 229);
  border: 2px solid rgb(191, 169, 46);
  margin: 20px auto;
}
.overflow-auto {
  height: 55vh;
  overflow-y: scroll;
}
.rigth-card {
  margin-top: 10px;
}

.rigth-card /deep/.el-card__body {
  padding: 5px !important;
}
.rigth-card:nth-of-type(2n) {
  margin-left: 20px;
}
.weigth {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
.weigth > div {
  width: 25%;
  font-size: 14px;
  padding: 4px;
  margin: 0 1px;
  text-align: center;
  box-shadow: 0 0 15px -6px;
}

.weigth > div:nth-of-type(1) {
  color: #67c23a;
}
.weigth > div:nth-of-type(2) {
  color: #409eff;
}
.weigth > div:nth-of-type(3) {
  color: #f56c6c;
}

.weigth > div > div:first-of-type {
  margin-bottom: 5px;
}
.rigth-card .el-form-item {
  margin-bottom: 0;
}
</style>
